import styled from 'vue-styled-components'

const Navigate = styled.div`
    svg {
        font-size: 12px;
        color: #53585D;
        margin-right: 6px;
        margin-left: 6px;
    }
    /* font-size: 12px;
    padding: 8px 4px;
    &:hover{
        box-shadow: 
    } */

`
const NavigateItem = styled.div`
    font-size: 14px;
    color: #24BEE2;
    cursor: pointer;
    &:last-child{
       color: #A5A5A5;
       cursor: default;
    }

`

export {
    Navigate,
    NavigateItem

}